import { forwardRef, Ref } from "react";
import { styled, TextField } from "@mui/material";
import { debounce } from "lodash-es";
import { useTranslation } from "react-i18next";

interface Props {
  search: string;
  updateSearch: (search: string) => void;
}

export const SearchBox = forwardRef(
  (props: Props, ref: Ref<HTMLInputElement | undefined> | undefined) => {
    const { search, updateSearch } = props;

    const { t } = useTranslation();

    const handleChangeWithLib = debounce((value) => {
      console.log("Bounce... bounce.... ");
      updateSearch(value.trim());
    }, 500);

    return (
      <StyledTextField
        defaultValue={search}
        inputRef={ref}
        placeholder={t("label.searchByLayerNameOrDescription")}
        onChange={(e) => {
          console.log("TRIGGERED EVENT");
          return handleChangeWithLib(e.target.value);
        }}
        variant="outlined"
      />
    );
  }
);

const StyledTextField = styled(TextField)`
  max-width: ${({ theme }) => theme.spacing(40)};
  width: 100%;
  .MuiInputBase-input {
    padding-top: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
